export default "__VITE_ASSET__Bm0j3koX__"